"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartQuery = void 0;
const vue_class_component_1 = require("vue-class-component");
function SmartQuery(options) {
    return (0, vue_class_component_1.createDecorator)((componentOptions, k) => {
        componentOptions.apollo = componentOptions.apollo || {};
        componentOptions.apollo[k] = options;
    });
}
exports.SmartQuery = SmartQuery;
//# sourceMappingURL=SmartQuery.js.map